import { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '../Button';

export interface CopyButtonProps {
  /** The exact text put on the clipboard. */
  value: string;
  /** Names what is copied, for screen readers ("Copy meta title"). */
  label?: string;
  className?: string;
}

/** A small "Copy" button that confirms with "Copied" for two seconds. */
export function CopyButton({ value, label = 'Copy', className }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      className={className}
      aria-label={label}
      leftIcon={copied ? <Check size={14} /> : <Copy size={14} />}
      onClick={copy}
    >
      {copied ? 'Copied' : 'Copy'}
    </Button>
  );
}
